import XLSX from 'xlsx';

export default {
    getExcelFileName(){
        return 'sheet-data.xlsx';
    },
    getSheetName(){
        return 'Test Data Sheet';
    },
    getExcelData(data){
        // return document.getElementById('sample-table'); 
        return data;
    },
    getWorksheet(data){
        return XLSX.utils.json_to_sheet(this.getExcelData(data));
    },
    s2ab(s) { 
        var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        var view = new Uint8Array(buf);  //create uint8array as viewer
        for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
        return buf;    
    },
    excelExport(data){ 
        // step 1. workbook 생성
        var wb = XLSX.utils.book_new();
        // step 2. 시트 만들기 
        var newWorksheet = this.getWorksheet(data);
        
        // step 3. workbook에 새로만든 워크시트에 이름을 주고 붙인다.  
        XLSX.utils.book_append_sheet(wb, newWorksheet, this.getSheetName());
        // step 4. 엑셀 파일 만들기 
        var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
        // step 5. 엑셀 파일 내보내기 
        saveAs(new Blob([this.s2ab(wbout)],{type:"application/octet-stream"}), this.getExcelFileName());
    },
    excelImport(){
        let input = event.target;
        let reader = new FileReader();
        reader.onload = function(){
            let fileData = reader.result;
            let wb = XLSX.read(fileData, {type : 'binary'});
            wb.SheetNames.forEach(function(sheetName){
                let rowObj =XLSX.utils.sheet_to_json(wb.Sheets[sheetName]);
            })
        };
        reader.readAsBinaryString(input.files[0]);

    },
    excelExportDataParser(data, column) {
        let temp = {};
        let output = [];
        for(let i in data){
            for (let j in column) {
                if (column[j].columnName == 'No') {
                    temp[column[j].columnName] = Number(i)+1;
                }else if(column[j].columnCode == 'No') {
                    temp[column[j].columnCode] = Number(i)+1;
                }else if(column[j].label == 'No') {
                    temp[column[j].label] = Number(i)+1;
                } else {
                    if (column[j].columnName) {
                        temp[column[j].columnName] = data[i][column[j].columnCode];
                    } else {
                        temp[column[j].label] = data[i][column[j].field];
                    }
                } 
            }
            output.push(temp);
            temp = {};
        }
        this.excelExport(output);
    },
}



// WEBPACK FOOTER //
// ./src/views/Common/excel.js